import { CircleOff } from 'lucide-react';
import React from 'react';

const LoadingSkeleton = ({ text }: { text: string }) => {
  return (
    <div className="w-full max-w-[1400px] mx-auto my-[30px] p-8 bg-gray-100 rounded-lg">
      <div className="flex flex-col items-center justify-center space-y-4">
        {/* Animated circle icon */}
        <div className="w-12 h-12 rounded-full bg-gray-200 animate-pulse">
          <div className="w-full h-full flex items-center justify-center">
            <CircleOff />
          </div>
        </div>

        {/* Static text */}
        <p className=" text-center">
          There are no saved {text} to show right now
        </p>

        {/* Loading text placeholder */}
        <div className="h-4 bg-gray-200 rounded animate-pulse w-64"></div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;
